import React from 'react';
import bindActionCreators from "redux/src/bindActionCreators";
import connect from "react-redux/es/connect/connect";
import {GoogleReCaptcha, withGoogleReCaptcha} from 'react-google-recaptcha-v3'
import config from "./../../config";
import classNames from 'classnames';
import validator from 'validator';
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import ModalLoader from "../common/ModalLoader";
import {
    closeLoginModal,
    showModalSpinner,
    hideModalSpinner,
    login,
    signup,
    forgotPassword,
    socialLogin,
    newsletterSignup,
    socialError
} from "../actionCreators/appAC";
import 'react-phone-number-input/style.css'
import PhoneInput,
{
    isPossiblePhoneNumber,
} from 'react-phone-number-input'
import {handleVerifyRecaptcha} from "../common/utils";


class LoginModal extends React.Component {
    constructor(props) {
        super(props);

        const country_code = this.props.init && this.props.init.x_country_code;
        const formDefaults = {
            email: { value: '', isValid: false, message: '' },
            password: { value: '', isValid: false, message: '' },
            phone: { value: '', isValid: false, message: '' },
        }

        this.state = {
            signup: true,
            form_valid: false,
            reset_pass: false,
            newsletter: country_code === "US",
            // non_promotional_sms_agreement: true,
            password_type: 'password',
            copy_success: 'click the code above to copy to clipboard',
            ...formDefaults
        };

        this.submitAuthRef = React.createRef();
        this.submitResetPassRef = React.createRef();
        this.submitNewsletterRef = React.createRef();
        this.changeType = this.changeType.bind(this);
        this.showHide = this.showHide.bind(this);
    }

    componentDidMount() {
        this.setState({
            signup: this.props.login_type === "signup"
        })
    }

    changeType(type) {
        this.resetValidationStates();
        this.setState({
            signup: type === "signup"
        }, this.props.handleLoginType(type));
    }

    showHide(){
        this.setState({
            password_type: this.state.password_type === 'input' ? 'password' : 'input'
        })
    }

    openNewsletterPopup() {
        this.resetValidationStates();
        this.setState({
            newsletter_popup: true
        });
    }

    openResetPass() {
        this.resetValidationStates();
        this.setState({
            reset_pass: true
        });
    }

    closeResetPass = () => {
        this.resetValidationStates();
        this.setState({
            reset_pass: false
        });
    }

    copyToClipboard = (e) => {
        this.textArea.select();
        document.execCommand('copy');
        // This is just personal preference.
        // I prefer to not show the the whole text area selected.
        e.target.focus();
        this.setState({ copy_success: 'Code copied to clipboard!' });
    };

    onInputChange = (e) => {
        const state = {
            ...this.state,
            [e.target.name]: {
                ...this.state[e.target.name],
                value: e.target.value,
            }
        };

        this.setState(state);
    }

    onPhoneChange = (e) => {
        const state = {
            ...this.state,
            ["phone"]: {
                ...this.state["phone"],
                value: e,
            }
        };

        this.setState(state);
    }

    onFormSubmit = (e, is_first_step) => {
        e.preventDefault();
        e.stopPropagation();

        const {signup, email, password, phone, newsletter, non_promotional_sms_agreement} = this.state;
        const {showModalSpinner, hideModalSpinner, from_checkout, googleReCaptchaProps} = this.props;

        if(this.formIsValid()){
            showModalSpinner();

            signup ?
                handleVerifyRecaptcha(googleReCaptchaProps, 'signup').then((token) => {
                    this.props.signup(
                        email.value,
                        password.value,
                        phone.value ? phone.value : null,
                        newsletter,
                        from_checkout,
                        non_promotional_sms_agreement,
                        is_first_step,
                        token
                    )
                })
                :
                this.props.login(email.value, password.value, from_checkout)
        } else {
            hideModalSpinner()
        }
    }

    onInputBlur = (type) => {
        this.setState({
            form_valid: this.inputIsValid(type)
        })
    }

    inputIsValid = (type) => {
        const {email, password, phone} = this.state;

        if (type === "email") {
            if (!validator.isEmail(email.value)) {
                email.isValid = false;
                email.message = 'Not a valid email address';
            } else {
                email.isValid = true;
                email.message = '';
            }
        }

        if (type === "password") {
            if (!validator.isLength(password.value, {min: 8}) && this.state.signup) {
                password.isValid = false;
                password.message = 'Password must be at least 8 characters long';
            } else if (!validator.isLength(password.value, {min: 4}) && !this.state.signup) {
                password.isValid = false;
                password.message = 'Password must be at least 4 characters long';
            } else {
                password.isValid = true;
                password.message = '';
            }
        }

        if (type === "phone") {
            if (phone.value && !isPossiblePhoneNumber(phone.value)) {
                phone.isValid = false;
                phone.message = 'Not a valid phone number';
            } else {
                phone.isValid = true;
                phone.message = '';
            }
        }

        this.setState({
            email,
            password,
            phone
        });

        return (this.state.reset_pass && email.isValid) || (email.isValid && password.isValid && phone.isValid);
    }

    resetValidationStates = () => {
        // make a copy of everything in state
        const state = JSON.parse(JSON.stringify(this.state));

        Object.keys(state).map(key => {
            if (state[key].hasOwnProperty('isValid')) {
                state[key].isValid = true;
                state[key].message = '';
            }
        });

        this.setState(state);
    }

    formIsValid = () => {
        const {is_first_step} = this.props;
        const email = { ...this.state.email };
        const password = { ...this.state.password };
        const phone = { ...this.state.phone };
        let isGood = true;
        email.message = "";
        password.message = "";
        phone.message = "";

        if (!validator.isEmail(email.value)) {
            email.isValid = false;
            email.message = 'Not a valid email address';
            isGood = false;
        }
        if (!is_first_step) {
            if (!validator.isLength(password.value, {min: 8}) && this.state.signup) {
                password.isValid = false;
                password.message = 'Password must be at least 8 characters long';
                isGood = false;
            }
            if (!validator.isLength(password.value, {min: 4}) && !this.state.signup) {
                password.isValid = false;
                password.message = 'Password must be at least 4 characters long';
                isGood = false;
            }
        }
        if (phone.value && !isPossiblePhoneNumber(phone.value)) {
            phone.isValid = false;
            phone.message = 'Not a valid phone number';
            isGood = false;
        }

        this.setState({
            email,
            password,
            phone
        });

        return isGood;
    }

    resetPassword = () => {
        const { email } = this.state;
        this.onInputBlur("email");
        if(email.isValid){
            this.props.forgotPassword(email.value);
        }
    }

    subscribeToNewsletter = () => {
        this.setState({
            newsletter: !this.state.newsletter
        })
    }
    subscribeToSms = () => {
        this.setState({
            sms: !this.state.sms
        })
    }

    newsletterSignup = () => {
        const { email, phone } = this.state;
        const { history } = this.props;
        this.onInputBlur("email");
        this.onInputBlur("phone");

        if(email.isValid && phone.isValid){
            this.props.newsletterSignup(email.value, phone.value ? phone.value : null);
            if (window.location.search.indexOf('NLModalSubscribe=true') > -1) {
                let urlParams = new URLSearchParams(window.location.search);
                urlParams.delete('NLModalSubscribe')
                if(history){
                    history.push({
                        search: urlParams.toString()
                    })
                }
            }
        }
    }

    handleKeyPressAuth = (e) => {
        if(e.key === 'Enter'){
            this.submitAuthRef.current.click();
        }
    }

    handleKeyPressReset = (e) => {
        if(e.key === 'Enter'){
            e.preventDefault();
            e.stopPropagation();
            this.submitResetPassRef.current.click();
        }
    }

    handleKeyPressNewsletter = (e) => {
        if(e.key === 'Enter'){
            e.preventDefault();
            e.stopPropagation();
            this.submitNewsletterRef.current.click();
        }
    }

    render() {
        const {
            login_type, mobile, mobile5s, resetLogin, signup_msg, error_msg,
            from_checkout, social_error, dismiss_able, is_first_step, sms_subscribed, email_subscribed,
        } = this.props;
        const {
            email, password, phone, newsletter, password_type, form_valid, reset_pass, signup,
            non_promotional_sms_agreement
        } = this.state;
        const newsletter_popup = (login_type && login_type === 'newsletter');

        const emailGroupClass = classNames('login-modal__form-group',
            { 'has-error': !email.isValid }
        );
        const phoneGroupClass = classNames('login-modal__form-group',
            { 'has-error': phone.value && !phone.isValid }
        );
        const passwordGroupClass = classNames('login-modal__form-group',
            { 'has-error': !password.isValid }
        );
        const passwordIconClass = classNames('login-modal__show-password-icon',
            { 'icon-eye-open': password_type === "password" },
            { 'icon-eye-closed': password_type === "input" }
        );

        const current_time = Date.now();
        const new_date = new Date(current_time + 12096e5);
        const nth = function(d) {
            if (d > 3 && d < 21) return 'th';
            switch (d % 10) {
                case 1:  return "st";
                case 2:  return "nd";
                case 3:  return "rd";
                default: return "th";
            }
        }
        const new_date_day = new_date.getDate();
        const new_date_month = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"][new_date.getMonth()];
        const new_date_year = new_date.getFullYear();

        const local_reset = () => {
            if(dismiss_able){
                this.props.closeLoginModal();
                resetLogin();
            }
        }

        return (
            <Modal
                show={true}
                size="lg"
                centered
                onHide={local_reset}
                className="login-modal rbg-popup-generic"
                container={document.getElementById('react-header')}
                backdropClassName="dark-overlay login-modal__dark-overlay"
            >
                <Modal.Header className="rbg-popup-generic__header">
                    {dismiss_able &&
                    <Button
                        className="rbg-popup-generic__close-icon"
                        onClick={local_reset}
                        variant="clean"
                        aria-label="Close"
                    >
                        <span className="icon-close" />
                    </Button>
                    }
                    <div id="fb-root"/>
                </Modal.Header>
                <Modal.Body className="rbg-popup-generic__body">
                    <div className="login-modal__container">
                        {!mobile &&
                        <div className="login-modal__left" style={{"backgroundImage": `url(${config.MEDIA_URL}/img/login-bkg-02-16-2023.jpg)`}}/>
                        }
                        <div className="login-modal__right">
                            {!reset_pass && !newsletter_popup && !social_error &&
                            <div className="login-modal__right--container">
                                <div className="login-modal__type-title--container">
                                    <Button
                                        className={`login-modal__type-title login-modal__signup-title ${signup && "login-modal__type-title--active"}`}
                                        onClick={() => this.changeType("signup")}
                                        variant="clean"
                                    >
                                        Sign up
                                    </Button>
                                    <Button
                                        className={`login-modal__type-title login-modal__login-title ${!signup && "login-modal__type-title--active"}`}
                                        onClick={() => this.changeType("login")}
                                        variant="clean"
                                    >
                                        Log in
                                    </Button>
                                </div>
                                {signup && !mobile5s &&
                                <h2
                                    className="login-modal__intro-text"
                                >
                                    <span className="login-modal__intro-text--inner">
                                        <span className="login-modal__intro-text--bottom">
                                            {signup_msg ?
                                                <>
                                                    {signup_msg} and get up to <strong>$300 USD OFF</strong> your first purchase
                                                </>
                                                :
                                                <>
                                                    and get up to $300 USD OFF your first purchase.
                                                </>
                                            }
                                        </span>
                                    </span>
                                </h2>
                                }
                                <Form
                                    noValidate
                                    className="login-modal__form"
                                >
                                    <Form.Group
                                        className={emailGroupClass}
                                        controlId="formGroupEmail"
                                    >
                                        <Form.Label
                                            className="login-modal__form-label"
                                        >
                                            Email address
                                        </Form.Label>
                                        <Form.Control
                                            className="login-modal__form-control"
                                            type="email"
                                            name="email"
                                            placeholder="Enter email"
                                            required
                                            value={email.value}
                                            onChange={this.onInputChange}
                                            onBlur={() => this.onInputBlur("email")}
                                            onKeyPress={this.handleKeyPressAuth}
                                            autoFocus
                                            disabled={!email.message && !error_msg && !is_first_step}
                                        />
                                        {email.message &&
                                        <span className="icon-error icon-exclamation"/>
                                        }
                                        <span className="login-modal__validation-failed">{email.message}</span>
                                    </Form.Group>
                                    {signup &&
                                        <Form.Group
                                            className={phoneGroupClass}
                                            controlId="formGroupPhone"
                                        >
                                            <Form.Label
                                                className="login-modal__form-label"
                                            >
                                                Phone <span className="login-modal__form-label--sublabel">(optional)</span>
                                            </Form.Label>
                                            <PhoneInput
                                                className="login-modal__form-control"
                                                name="phone"
                                                placeholder="(555) 123-456"
                                                defaultCountry="US"
                                                international
                                                value={phone.value}
                                                onChange={this.onPhoneChange}
                                                onBlur={() => this.onInputBlur("phone")}
                                                onKeyPress={this.handleKeyPressAuth}
                                                autoFocus
                                                disabled={!is_first_step}
                                            />
                                            {phone.message && phone.value &&
                                            <span className="icon-error icon-exclamation"/>
                                            }
                                            {phone.value &&
                                            <span className="login-modal__validation-failed">{phone.message}</span>
                                            }
                                        </Form.Group>
                                    }
                                    {(!signup || (signup && !is_first_step)) &&
                                        <Form.Group
                                            className={passwordGroupClass}
                                            controlId="formGroupPassword"
                                        >
                                            <Form.Label
                                                className="login-modal__form-label"
                                            >
                                                Password
                                            </Form.Label>
                                            <Form.Control
                                                className="login-modal__form-control"
                                                type={password_type}
                                                name="password"
                                                placeholder="Password"
                                                value={password.value}
                                                onChange={this.onInputChange}
                                                onBlur={() => this.onInputBlur("password")}
                                                onKeyPress={this.handleKeyPressAuth}
                                            />
                                            {!password.message &&
                                            <Button
                                                onClick={this.showHide}
                                                variant="clean"
                                                className="login-modal__show-password"
                                            >
                                                <span className={`login-modal__show-password-icon ${passwordIconClass}`} />
                                            </Button>
                                            }
                                            {password.message &&
                                            <span className="icon-error icon-exclamation"/>
                                            }
                                            {!signup &&
                                            <Button
                                                className="login-modal__forgotten-pass-text"
                                                onClick={() => this.openResetPass()}
                                                variant="clean"
                                            >
                                                Forgot  password?
                                            </Button>
                                            }
                                            <span className="login-modal__validation-failed">{password.message}</span>
                                            <div className={`login-modal__google-terms${signup ? '' : '--login'}`}>
                                                This site is protected by reCAPTCHA and the Google{' '}
                                                <a href="https://policies.google.com/privacy">Privacy Policy</a> and{' '}
                                                <a href="https://policies.google.com/terms">Terms of Service</a> apply.
                                            </div>
                                        </Form.Group>
                                    }
                                    <Button
                                        className="rbg-btn-black login-modal__submit"
                                        variant="secondary"
                                        id={form_valid ? "login-modal__submit" : ""}
                                        onClick={(e) => this.onFormSubmit(e, is_first_step)}
                                        ref={this.submitAuthRef}
                                    >
                                        {signup ? (is_first_step ? "Continue" : "Sign up") : "Log In"}
                                    </Button>
                                    <span className="login-modal__server-validation-failed">{error_msg}</span>
                                </Form>
                                <Button
                                    id="login-modal__facebook"
                                    className="login-modal__facebook--container"
                                    onClick={() => this.props.socialLogin(from_checkout)}
                                    variant="clean"
                                >
                                    <span className="login-modal__facebook--text">Or continue with</span>
                                    <span className="icon-facebook login-modal__facebook--icon"/>
                                </Button>
                                {signup &&
                                <div className="login-modal__terms">By signing up you accept our <a href={`${config.host_rebag}/terms/`} target="_blank">
                                        Terms of Use
                                    </a> and <a href={`${config.host_rebag}/terms/?#privacy`} target="_blank">
                                        Privacy Policy
                                    </a>.
                                </div>
                                }
                            </div>
                            }
                            {signup && !is_first_step &&
                                <div className="login-modal__optin">
                                    {!email_subscribed &&
                                    <Form.Check
                                        custom
                                        name="offers"
                                        label=""
                                        className="login-modal__offers"
                                        id="login-modal__offers"
                                    >
                                        <Form.Check.Input
                                            onClick={this.subscribeToNewsletter}
                                            defaultChecked={newsletter}
                                        />
                                        <Form.Check.Label>
                                            Sign up for exclusive email offers and promotions
                                        </Form.Check.Label>
                                    </Form.Check>
                                    }
                                    {!sms_subscribed && phone.value &&
                                    <Form.Check
                                        custom
                                        name="offers"
                                        label=""
                                        className="login-modal__offers"
                                        id="non_promotional_sms_agreement"
                                    >
                                        <Form.Check.Input
                                            onClick={() => this.setState({non_promotional_sms_agreement: !non_promotional_sms_agreement})}
                                            defaultChecked={non_promotional_sms_agreement}
                                        />
                                        <Form.Check.Label>
                                            By submitting this form, you agree to receive recurring automated
                                            promotional and personalized marketing text messages (e.g. cart reminders)
                                            from Rebag at the cell number used when signing up.
                                            Consent is not a condition of any purchase.
                                            Reply HELP for help and STOP to cancel. Msg frequency varies. Msg and data
                                            rates may apply. View Terms & Privacy.
                                        </Form.Check.Label>
                                    </Form.Check>
                                    }
                                </div>
                            }
                            {reset_pass &&
                            <div className="login-modal__right--container">
                                <p className="login-modal__reset-pass-title">Reset Password</p>
                                <div className="login-modal__title-subline"/>
                                <h2 className="login-modal__reset-pass-intro-text">
                                    Please enter your email below and we'll send instruction to reset your password
                                </h2>
                                <Form
                                    noValidate
                                    className="login-modal__form"
                                >
                                    <Form.Group
                                        className={emailGroupClass}
                                        controlId="formGroupEmail"
                                    >
                                        <Form.Label
                                            className="login-modal__form-label"
                                        >
                                            Email address
                                        </Form.Label>
                                        <Form.Control
                                            className="login-modal__form-control"
                                            type="email"
                                            name="email"
                                            placeholder="Enter email"
                                            required
                                            value={email.value}
                                            onChange={this.onInputChange}
                                            onBlur={() => this.onInputBlur("email")}
                                            onKeyPress={this.handleKeyPressReset}
                                            autoFocus
                                        />
                                        {(email.message || error_msg) &&
                                        <span className="icon-error icon-exclamation"/>
                                        }
                                        <span className="login-modal__validation-failed">{email.message || error_msg}</span>
                                    </Form.Group>
                                    <Button
                                        className="rbg-btn-black login-modal__submit login-modal__recover"
                                        variant="secondary"
                                        id={form_valid ? "login-modal__submit" : ""}
                                        onClick={this.resetPassword}
                                        ref={this.submitResetPassRef}
                                    >
                                        Reset Password
                                    </Button>
                                    <Button
                                        className="login-modal__recover-cancel"
                                        onClick={this.closeResetPass}
                                        variant="clean"
                                    >
                                        Cancel
                                    </Button>
                                </Form>
                            </div>
                            }
                            {newsletter_popup &&
                            <div className="login-modal__right--container">
                                <p className="login-modal__newsletter-top-title">Sign up and get up to</p>
                                <p className="login-modal__newsletter-middle-title">$300 USD off</p>
                                <p className="login-modal__newsletter-bottom-title">on your first purchase</p>
                                <div className="login-modal__title-subline"/>
                                <h2 className="login-modal__newsletter-intro-text">
                                    Receive offers, product alerts, styling inspiration and more...
                                </h2>
                                <Form
                                    noValidate
                                    className="login-modal__form"
                                >
                                    <Form.Group
                                        className={emailGroupClass}
                                        controlId="formGroupEmail"
                                    >
                                        <Form.Label
                                            className="login-modal__form-label"
                                        >
                                            Email address
                                        </Form.Label>
                                        <Form.Control
                                            className="login-modal__form-control"
                                            type="email"
                                            name="email"
                                            placeholder="Enter email"
                                            required
                                            value={email.value}
                                            onChange={this.onInputChange}
                                            onBlur={() => this.onInputBlur("email")}
                                            onKeyPress={this.handleKeyPressNewsletter}
                                            autoFocus
                                        />
                                        {(email.message || error_msg) &&
                                        <span className="icon-error icon-exclamation"/>
                                        }
                                        <span className="login-modal__validation-failed">{email.message || error_msg}</span>
                                    </Form.Group>
                                    <Form.Group
                                        className={phoneGroupClass}
                                        controlId="formGroupPhone"
                                    >
                                        <Form.Label
                                            className="login-modal__form-label"
                                        >
                                            Phone <span className="login-modal__form-label--sublabel">(optional)</span>
                                        </Form.Label>
                                        <PhoneInput
                                            className="login-modal__form-control"
                                            name="phone"
                                            placeholder="(555) 123-456"
                                            defaultCountry="US"
                                            international
                                            value={phone.value}
                                            onChange={this.onPhoneChange}
                                            onBlur={() => this.onInputBlur("phone")}
                                            onKeyPress={this.handleKeyPressAuth}
                                            autoFocus
                                        />
                                        {phone.message && phone.value &&
                                        <span className="icon-error icon-exclamation"/>
                                        }
                                        {phone.value &&
                                        <span className="login-modal__validation-failed">{phone.message}</span>
                                        }
                                    </Form.Group>
                                    <Button
                                        className="rbg-btn-black login-modal__submit login-modal__newsletter-cta"
                                        variant="secondary"
                                        id={form_valid ? "login-modal__submit" : ""}
                                        onClick={this.newsletterSignup}
                                        ref={this.submitNewsletterRef}
                                    >
                                        Sign Up
                                    </Button>
                                    <div className="login-modal__newsletter-terms">By signing up you accept our <a
                                        href={`${config.host_rebag}/terms/`} target="_blank">Terms of Use
                                    </a> and <a href={`${config.host_rebag}/terms/?#privacy`} target="_blank">Privacy Policy</a>,
                                        including receipt of emails and promotions. You can unsubscribe at any time. This Offer is not cumulative with other offers
                                    </div>
                                </Form>
                            </div>
                            }
                            {social_error &&
                                <div className="login-modal__right--container login-modal__right--social-error">
                                    <p className="login-modal__reset-pass-title">Sorry</p>
                                    <div className="login-modal__title-subline"/>
                                    <h2 className="login-modal__reset-pass-intro-text login-modal__reset-pass-intro-text--social-error">Your FB account is not associated with any email so we cannot let you sign-in with your Facebook Account - please create a Rebag account with an email address instead</h2>
                                    <Button
                                        className="rbg-btn-black login-modal__submit"
                                        variant="secondary"
                                        onClick={() => {this.props.socialError(false); this.changeType('signup')}}
                                    >
                                        Sign Up
                                    </Button>
                                </div>
                            }
                        </div>
                    </div>
                    <ModalLoader/>
                </Modal.Body>
            </Modal>
        )
    }
}

const mapStateToProps = function (state) {
    const {
        login_type, from_checkout, init, social_error, dismiss_able, is_first_step,
        email_subscribed,
        sms_subscribed
    } = state.appReducer;
    return {
        login_type, from_checkout, init, social_error, dismiss_able, is_first_step,
        email_subscribed,
        sms_subscribed
    };
};

const mapDispatchToProps = function (dispatch) {
    return bindActionCreators({
        login,
        socialLogin,
        signup,
        forgotPassword,
        closeLoginModal,
        showModalSpinner,
        hideModalSpinner,
        newsletterSignup,
        socialError
    }, dispatch);
};

export default withGoogleReCaptcha(connect(mapStateToProps, mapDispatchToProps)(LoginModal));